export default __webpack_public_path__ + "static/media/Giant Fist.bf4ede65.png";